// When you want a static aspect ratio, you can use the padding-top trick in
// combination without position relative. This function calculates the
// appropriate percentage.
// Example values: width 16, height 9 (16:9 aspect ratio)
const getPaddingTopFromAspectRatio = (width: number, height: number) =>
  height / width

export default getPaddingTopFromAspectRatio
